
define('services/myreport/myreport-all.service',['app','mainCons'], function (app,mainCons) {
    return app.factory('reportUtil', ['OpenOther', 'auiTeamAccountService','ngDialog',function (OpenOther,auiTeamAccountService,ngDialog) {

        /**
         *array:待处理的报表数组
         *xFiledName:X轴的字段
         *sortType：0：保持原状、1：升序、2：降序
         *yFiledNameArray：数组。 Y轴的字段。
         */
        function getXYFromBI(array, xFiledName, sortType, yFiledNameArray) {
            if (!array || Object.prototype.toString.call(array) !== '[object Array]') {
                return;
            }
            if (sortType !== 0) {
                array.sort(function (a, b) {
                    var aDate = new Date(a[xFiledName].replace(/-/g, "/"));
                    var bDate = new Date(b[xFiledName].replace(/-/g, "/"));
                    if (sortType === 1) {
                        return aDate > bDate ? 1 : -1;
                    } else {
                        return aDate < bDate ? 1 : -1;
                    }
                });
            }
            var result = {};
            result[xFiledName] = [];
            for (var yName in yFiledNameArray) {
                result[yFiledNameArray[yName]] = [];
            }

            for (var i in array) {
                result[xFiledName].push(array[i][xFiledName]);
                for (var j in yFiledNameArray) {
                    result[yFiledNameArray[j]].push(array[i][yFiledNameArray[j]]);
                }
            }
            return result;
        }

        function showSearchCountryDlg(args) {
            !args && (args = {});
            var handler = ngDialog.open({
                template: 'pages/common/search.country.html',
                className: '',
                closeByEscape: false,
                closeByDocument: false,
                overlay: false,
                controller: ['$scope', '$timeout', function ($scope, $timeout) {
                    var Model = $scope.Model = {
                        countrys: [],
                        initCountrys:[],
                        shortName: '',
                        noData: '暂无数据',
                        selected: [],
                        selectedCountryName:[]
                    };
                    initCountrys();

                    $scope.searchCountry = searchCountry;
                    $scope.selectOne = selectOne;

                    function initCountrys(){
                        auiTeamAccountService.getRealNameCountryList().then(function (data) {
                            var countryCodeList = mainCons.reportAll.countryCodeList;
                            var newCountryList = [];

                            countryCodeList.forEach(function(code) {
                                data.allContrysFromInterface.forEach(function(item) {
                                    if(code === item.country) {
                                        newCountryList.push({country: code, shortName: item.shortName})
                                    }
                                })
                            })
                            Model.countrys = newCountryList;
                            sysParamCfg.unSuportCountryInfo.forEach(function(item) {
                                Model.countrys.push({country: item.simple, shortName: item.countryName})
                            })
                            Model.countrys = Model.countrys.sort(
                                function compareFunction(country1, country2) {
                                	return country1.shortName.localeCompare(country2.shortName,"zh");
                                }
                            );
                            Model.initCountrys = angular.copy(Model.countrys);
                        });
                    }
                    function searchCountry() {
                        if(!Model.shortName){
                        	Model.countrys = Model.initCountrys;
                            return;
                        }
                        Model.countrys = [];
                        for (var i = 0; i < Model.initCountrys.length; i++) {
                            if (Model.initCountrys[i].shortName.indexOf(Model.shortName) >= 0) {
                                Model.countrys.push(Model.initCountrys[i]);
                            }
                        }
                    }

                    function selectOne(value) {
                        if(Model.selected.indexOf(value.country) != -1){
                            Model.selected.splice(Model.selected.indexOf(value.country), 1);
                        }else{
                            Model.selected.push(value.country);
                        }
                        if(Model.selectedCountryName.indexOf(value.shortName) != -1){
                            Model.selectedCountryName.splice(Model.selectedCountryName.indexOf(value.shortName), 1);
                        }else{
                            Model.selectedCountryName.push(value.shortName);
                        }
                    }

                    //关闭页面
                    Model.close = function () {
                        handler.close();
                    };
                    //保存
                    Model.doSubmit = function () {
                        if(!Model.selected || Model.selected.length == 0){
                            return;
                        }
                        args.callBack  && (args.callBack(Model.selected.join(','),Model.selectedCountryName.join(',')) , Model.close());
                    };

                }]
            });
        }

        return {
            getXYFromBI: getXYFromBI,
            showSearchCountryDlg:showSearchCountryDlg
        }

    }]);
});


